import { ZodError } from 'zod';
import { fromZodError } from 'zod-validation-error';

export interface ErrorMessageProps {
  path: string;
  message: string;
}

interface ErrorPathProps {
  path: string;
}

export interface ErrorFormatterProps {
  errorPaths: string[];
  errorMessages: ErrorMessageProps;
}

export const errorFormatter = (errorMessage: ZodError<ErrorFormatterProps>) => {
  const validationError = fromZodError(errorMessage);

  const errorMessages = Object.values(validationError)[1].map(
    (path: ErrorMessageProps) => {
      return { path: path.path[0], message: path.message };
    },
  );

  const errorPaths = Object.values(validationError)[1].map(
    (path: ErrorPathProps) => {
      return path.path[0];
    },
  );

  return { errorPaths, errorMessages };
};
